import React from "react";
import { useSelector } from "react-redux";
import { getCart } from "./../redux/products/productsReducer";

const CartFooter = () => {
  const Products = useSelector(getCart);

  const totalQty = Products.reduce((acc, cv) => acc + cv.Qty, 0);
  const totalPrice = Products.reduce(
    (acc, cv) => acc + cv.Qty * cv.productPrice,
    0
  );
  return (
    <div>
      <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        <div className="flex justify-center items-center text-center">
          <div className="text-xl font-semibold">
            <p>Total Item</p>
            <p className="text-5xl">{totalQty}</p>
          </div>
        </div>
      </div>
      <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        <div className="flex justify-center items-center text-center">
          <div className="text-xl font-semibold">
            <p>Total Price</p>
            <p className="text-5xl">Tk. {totalPrice.toLocaleString("en-US")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartFooter;
